import { PostalCodesGridView } from '~/components/system/postal-codes';
import { PageContainer } from '~/components/page-container';

export function PostalCodes() {
	return (
		<PageContainer>
			<PostalCodesGridView />
		</PageContainer>
	);
}
